import { ChevronDown } from "lucide-react";

// ─── NATIVE DATE/TIME PICKER INPUT ─────────────────────────────────────────
// Wraps a bare <input type="date"|"time"> so its picker affordance is a real
// React icon with guaranteed spacing, instead of the browser/OS's own
// indicator — see the comment above the global
// ::-webkit-calendar-picker-indicator rule in App.jsx for why: on Android's
// native WebView, CSS aimed at that pseudo-element's box model (margin,
// padding) has no visible effect, so no such tweak can be trusted to move
// it off the field's edge.
// That global rule makes the native indicator invisible and stretches its
// tappable hit-region across the whole input — so every use of this
// component gets "tap anywhere on the field" for free — and this component
// then draws the actual visible chevron on top, positioned with normal,
// reliable CSS.
//
// Desktop browsers differ: Chrome only opens the picker from the (hidden)
// indicator, and clicking anywhere else on the field just focuses a typing
// segment ("dd"), so the chevron looked dead. With a mouse (pointer: fine) we
// open the picker explicitly on click. Touch devices, including the Android
// WebView, already open it natively on tap, so they're left alone.
function openPickerForMouse(e) {
  try {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    if (typeof e.currentTarget.showPicker === "function") e.currentTarget.showPicker();
  } catch (_) { /* already open, or not allowed right now — typing still works */ }
}

export function NativePickerInput({ type, style = {}, onClick, ...rest }) {
  const { opacity, width, ...inputStyle } = style;
  return (
    <div style={{ position: "relative", width: width ?? "100%", opacity }}>
      <input
        type={type}
        {...rest}
        onClick={(e) => { openPickerForMouse(e); if (onClick) onClick(e); }}
        style={{ ...inputStyle, width: "100%", boxSizing: "border-box", paddingRight: 36 }}
      />
      <ChevronDown
        size={16}
        style={{
          position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
          pointerEvents: "none", color: "#a07090",
        }}
      />
    </div>
  );
}
